// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.ui-input[data-v-0dc14978] {
  padding-top: 1rem;
  padding-bottom: 1rem;
}
label[data-v-0dc14978] {
  position: relative;
  display: block;
}
input[data-v-0dc14978] {
  font-family: var(--primary-font);
  font-size: 1rem;
  line-height: 1.25;
  border: none;
  display: block;
  width: 100%;
  padding: 0.5rem 1rem;
  color: var(--text-contrast-color);
  outline: none;
  background-color: transparent;
  background-position: 100% 100%;
  background-repeat: no-repeat;
  background-size: 200% 1px;
  background-image: linear-gradient(
    to right,
    var(--dark) 0,
    var(--dark) 50%,
    var(--input-color) 50%,
    var(--input-color) 100%
  );
  transition: background-position var(--input-time) ease-in-out;
}
input[data-v-0dc14978]:disabled {
  opacity: 0.5;
}
.input-name[data-v-0dc14978] {
  color: var(--text-contrast-color);
  line-height: 1.5;
  display: block;
  position: absolute;
  top: 0.5rem;
  left: 1rem;
  font-weight: 400;
  transition: all var(--input-time) ease-in-out;
}
.input-error[data-v-0dc14978] {
  font-size: 0.75rem;
  color: var(--error);
  position: absolute;
  bottom: -1rem;
  opacity: 0;
  transition: opacity var(--input-time) ease-in-out;
}
.ui-touched .input-error[data-v-0dc14978] {
  opacity: 1;
}
input[data-v-0dc14978]:focus {
  background-position: 0 100%;
}
.not-empty .input-name[data-v-0dc14978],
input:focus + .input-name[data-v-0dc14978] {
  font-size: 0.75rem;
  top: -1rem;
  left: 0;
}
.has-error.ui-touched > input[data-v-0dc14978] {
  --input-color: var(--error);
}
.has-error.ui-touched > .input-name[data-v-0dc14978] {
  color: var(--error);
}
`, "",{"version":3,"sources":["webpack://./src/components/ui/UiInput.vue"],"names":[],"mappings":";AAuDA;EACA,iBAAA;EACA,oBAAA;AACA;AAEA;EACA,kBAAA;EACA,cAAA;AACA;AAEA;EACA,gCAAA;EACA,eAAA;EACA,iBAAA;EACA,YAAA;EACA,cAAA;EACA,WAAA;EACA,oBAAA;EACA,iCAAA;EACA,aAAA;EACA,6BAAA;EACA,8BAAA;EACA,4BAAA;EACA,yBAAA;EACA;;;;;;GAMA;EACA,6DAAA;AACA;AAEA;EACA,YAAA;AACA;AAEA;EACA,iCAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,WAAA;EACA,UAAA;EACA,gBAAA;EACA,6CAAA;AACA;AAEA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;EACA,aAAA;EACA,UAAA;EACA,iDAAA;AACA;AAEA;EACA,UAAA;AACA;AAEA;EACA,2BAAA;AACA;AAEA;;EAEA,kBAAA;EACA,UAAA;EACA,OAAA;AACA;AAEA;EACA,2BAAA;AACA;AAEA;EACA,mBAAA;AACA","sourcesContent":["<template>\n  <div class=\"ui-input\">\n    <label :class=\"[{ 'not-empty': value, 'has-error': error }, touchedClass]\">\n      <input\n        :type=\"type\"\n        :value=\"value\"\n        :disabled=\"disabled\"\n        :maxlength=\"maxLength\"\n        @input=\"inputChange\"\n        @blur=\"lostFocus\"\n      />\n      <span class=\"input-name\">{{ $t(label) }}</span>\n      <span class=\"input-error\">{{ $t(error) }}</span>\n    </label>\n  </div>\n</template>\n\n<script>\nexport default {\n  name: 'ui-input',\n\n  props: {\n    value: { type: String, default: undefined },\n    error: { type: String, default: undefined },\n    label: { type: String, default: undefined },\n    type: { type: String, default: 'text' },\n    maxLength: { type: [String, Number], default: 256 },\n    disabled: Boolean\n  },\n\n  data() {\n    return {\n      isTouched: false\n    }\n  },\n\n  computed: {\n    touchedClass() {\n      return this.isTouched ? 'ui-touched' : 'ui-untouched'\n    }\n  },\n\n  methods: {\n    inputChange(event) {\n      this.$emit('input', event.target.value)\n    },\n\n    lostFocus() {\n      this.isTouched = true\n    }\n  }\n}\n</script>\n\n<style scoped>\n.ui-input {\n  padding-top: 1rem;\n  padding-bottom: 1rem;\n}\n\nlabel {\n  position: relative;\n  display: block;\n}\n\ninput {\n  font-family: var(--primary-font);\n  font-size: 1rem;\n  line-height: 1.25;\n  border: none;\n  display: block;\n  width: 100%;\n  padding: 0.5rem 1rem;\n  color: var(--text-contrast-color);\n  outline: none;\n  background-color: transparent;\n  background-position: 100% 100%;\n  background-repeat: no-repeat;\n  background-size: 200% 1px;\n  background-image: linear-gradient(\n    to right,\n    var(--dark) 0,\n    var(--dark) 50%,\n    var(--input-color) 50%,\n    var(--input-color) 100%\n  );\n  transition: background-position var(--input-time) ease-in-out;\n}\n\ninput:disabled {\n  opacity: 0.5;\n}\n\n.input-name {\n  color: var(--text-contrast-color);\n  line-height: 1.5;\n  display: block;\n  position: absolute;\n  top: 0.5rem;\n  left: 1rem;\n  font-weight: 400;\n  transition: all var(--input-time) ease-in-out;\n}\n\n.input-error {\n  font-size: 0.75rem;\n  color: var(--error);\n  position: absolute;\n  bottom: -1rem;\n  opacity: 0;\n  transition: opacity var(--input-time) ease-in-out;\n}\n\n.ui-touched .input-error {\n  opacity: 1;\n}\n\ninput:focus {\n  background-position: 0 100%;\n}\n\n.not-empty .input-name,\ninput:focus + .input-name {\n  font-size: 0.75rem;\n  top: -1rem;\n  left: 0;\n}\n\n.has-error.ui-touched > input {\n  --input-color: var(--error);\n}\n\n.has-error.ui-touched > .input-name {\n  color: var(--error);\n}\n</style>\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
